/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */
import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";
// import { useNavigate, Link } from 'react-router-dom'

const ServiceListItem = (props) => {

    const { icon_link } = props || {};
    const { link, icon } = icon_link || {};
    const { text, url } = link || {};

    return (
        <Fragment>
            {icon_link && (
                <div className='service-list-item'>
                    <NavLink
                        aria-label={text}
                        to={url}
                        className='common-tasks-link'
                    >
                    {/*<a href={`${url}`} className='common-tasks-link' aria-label={text}>*/}
                        {/*<span className={`common-tasks-icon ${icon_lib} ${icon}`}></span>*/}
                        <div className='common-tasks-icon'>
                            {icon &&
                                <FontAwesomeIcon icon={`fa-regular ${icon}`} size={"2x"} />
                            }
                        </div>
                        <div className='common-tasks-text'>{text}</div>
                    {/*</a>*/}
                    </NavLink>
                </div>
            )}
        </Fragment>
    );

    // TODO: Testing Local navigation - needs better detection of not found
    // const navigate = useNavigate()
    // return (
    //     <Fragment>
    //         {service && (
    //             <div className='common-tasks-items-item'>
    //                 <Link to={url} className='common-tasks-link'>
    //                     <span className={`common-tasks-icon ${icon_lib} ${icon}`}></span>
    //                     <span className="common-tasks-text">{text}</span>
    //                 </Link>
    //             </div>
    //         )}
    //     </Fragment>
    // )
};
export { ServiceListItem };
